import { useEffect, useRef } from 'react';

type ScrollRefs = Record<string, HTMLDivElement | null>;

export const useScrollToAccordionItem = (openValue: string, offset = 80) => {
  const refs = useRef<ScrollRefs>({});
  const previousOpenValue = useRef<string | null>(null);

  useEffect(() => {
    if (previousOpenValue.current === null) {
      previousOpenValue.current = openValue;

      return;
    }

    if (previousOpenValue.current === openValue) {
      return;
    }

    previousOpenValue.current = openValue;

    if (!openValue) {
      return;
    }

    const timeout = setTimeout(() => {
      requestAnimationFrame(() => {
        const el = refs.current[openValue];
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: y - offset, behavior: 'smooth' });
        }
      });
    }, 250);

    return () => clearTimeout(timeout);
  }, [openValue, offset]);

  return refs;
};
